export default "__VITE_ASSET__3d6267ad__"